import React from 'react'
import PropTypes from 'prop-types'
import FormFieldError from '../FormFieldError'
import TextareaAutosize from 'react-autosize-textarea'

// todo: add JS resize textarea based on rows of text http://jsfiddle.net/tovic/gLhCk/

const Textarea = ({ autoResize, input, label, maxRows, meta, placeholder, subText, ...rest }) => (
  <div>
    <div className="form-group">
      {label && <label>{label}</label>}
      {autoResize ? (
        <TextareaAutosize
          className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
          disabled={meta.submitting}
          maxLength={20000}
          maxRows={maxRows}
          placeholder={placeholder}
          {...input}
          {...rest}
        />
      ) : (
        <textarea
          className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
          disabled={meta.submitting}
          maxLength={20000}
          placeholder={placeholder}
          {...input}
          {...rest}
        />
      )}

      {subText && <small className="form-text text-muted">{subText}</small>}

      <FormFieldError {...meta} />
    </div>
  </div>
)

Textarea.propTypes = {
  autoResize: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  input: PropTypes.object, // passed from react-final-form or redux-form
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.node]),
  maxRows: PropTypes.number,
  meta: PropTypes.object, // passed from react-final-form or redux-form
  name: PropTypes.string,
  placeholder: PropTypes.string,
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.node]),
}
Textarea.defaultProps = {
  autoResize: false,
  input: {},
  label: '',
  maxRows: 10,
  meta: {},
  name: '',
  placeholder: '',
  subText: undefined,
}

export default Textarea
